import createAction from './createAction';
// because icepick is implemented using commonjs modules,
// which we don't suppport, it has to be required in this way
const icepick = require('../../../node_modules/icepick/icepick.min.js');

const UISettings = require('../../utils/UISettings.js');

// 1. Initial state
const initialState = icepick.freeze({
  // Initially react will not render banners into listing page,
  // server rendered banner will remain on page until user select some (specific) filter.
  headerBanner: {}
});

// 2. Actions
const SET_HEADER_BANNER = 'listingPage/banners/SET_HEADER_BANNER';

// 3. Action creators
export function setHeaderBanner(payload) {
  if (payload === undefined) {
    const ajaxSettings = UISettings.get('component.listing-page-products.ajax-settings');
    return createAction(SET_HEADER_BANNER)(ajaxSettings.banner);
  }

  return createAction(SET_HEADER_BANNER)(payload);
}

// 4. Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_HEADER_BANNER: {
      return icepick.setIn(state, ['headerBanner'], action.payload);
    }
    default: {
      return state;
    }
  }
}
